<template>
    <div class="container">
        <div class="main">

            <!-- 官方授权实体店 -->
            <div class="panel">
                <div class="panel_title">官方授权实体店</div>
                <div class="panel_line"></div>

                <div class="panel_search">
                    <el-form :inline="true" label-width="60px" label-suffix="：" class="search_form">
                        <el-form-item label="省份" prop="ptype">
                            <el-select v-model="province" @change="changeProv" placeholder="请选择省份" style="width: 180px">
                                <el-option v-for="item in provinces"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="城市" prop="ptype">
                            <el-select v-model="city" @change="changeCity" placeholder="请选择城市" style="width: 180px">
                                <el-option
                                        v-for="item in citys"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="dealer_list">
                    <el-card class="box-card" v-for="i in dealerList" :key="i.id" style="margin-bottom: 20px">
                        <div style="font-size: 20px">{{i.dealerName}}</div>
                        <div style="margin-left: 2px;padding-top: 10px">联系人：{{i.contactName}}</div>
                        <div style="margin-left: 2px;padding-top: 10px">电话：{{i.contactPhone}}</div>
                        <div style="margin-left: 2px;padding-top: 10px">地址：{{i.address}}</div>
                    </el-card>
                </div>
            </div>

            <!-- 官方授权网店 -->
            <div class="panel">
                <div class="panel_title">官方授权网店</div>
                <div class="panel_line"></div>

                <div class="online_list">
                    <div class="online_item" @click="tmallClick">
                        <img class="online_icon" :src="require('@/assets/image/home/home6/tmall1.png')">
                        <div class="online_name">DIXCEL 天猫旗舰店</div>
                    </div>
                    <div class="online_item" @click="jdClick">
                        <img class="online_icon" :src="require('@/assets/image/home/home6/jd1.png')">
                        <div class="online_name">DIXCEL 京东旗舰店</div>
                    </div>
                </div>
            </div>

             <!-- 官方查询小程序 -->
            <div class="panel">
                <div class="panel_title">官方查询小程序</div>
                <div class="panel_line"></div>

                <div class="online_list">
                    <div class="online_item">
                        <img class="online_qrcode" :src="require('@/assets/image/home/home6/xcx.jpg')">
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
    import axios from 'axios';
    export default {
        name: 'dealerDetail',
        data() {
            return {
                // loading:true,
                provinces: [ ],
                citys: [],
                cityAll: [],
                dealerAllList: [],
                dealerList: [],
                province: '',
                city: '',

            }
        },
        created(){
            this.getDealerList()
        },
        methods:{
            tmallClick(){
                window.open( 'https://dixcel.tmall.com' , '_blank' )
            },
            jdClick(){
                window.open( 'https://mall.jd.com/index-735062.html' , '_blank' )
            },
                getCity() {
                    axios.get(this.publicUrl+'/api/user/getCity')
                        .then(response => {
                            this.provinces=JSON.parse(response.data.provinces)
                            this.cityAll=JSON.parse(response.data.citys)
                        })
                        .catch(error => {
                            console.error('There was an error!', error);
                        });
                },
                 getDealerList(){
                    axios.get(this.publicUrl+'/api/user/getDealerList')
                    .then(res => {
                        this.dealerAllList=res.data.list;
                        this.loading=false;
                        this.getCity()
                    })
                    .catch(error => {
                        console.error('There was an error!', error);
                    });
                },
                changeProv(){
                    this.citys =this.cityAll[this.province]
                    this.city = this.citys[0].id
                    this.changeCity()
                },
                changeCity(){
                    this.dealerList=[];
                    for(const d of this.dealerAllList){
                        if(d.cityCode == this.city){
                          if (d.address) {
                            d.address = d.address
                                .replace('北京北京市', '北京市')
                                .replace('上海上海市', '上海市')
                                .replace('重庆重庆市', '重庆市')
                                .replace('天津天津市', '天津市')
                          }
                            this.dealerList.push(d)
                        }

                    }

                }


            }
    }
</script>

<style lang="stylus" scoped>


    .container
        background-color: #f5f5f5
        padding: 20px 0

    .main
        width: 1003px
        margin: 0 auto
        box-sizing: border-box

    /* 分区白底卡片 */
    .panel
        background-color: #fff
        border: 1px solid #e8e8e8
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06)
        box-sizing: border-box
        padding: 38px 50px 45px
        margin-bottom: 22px

    /* 红色居中标题 */
    .panel_title
        color: #d0021b
        font-size: 22px
        font-weight: bold
        text-align: center
        letter-spacing: 2px

    /* 标题下方红色分隔线 */
    .panel_line
        height: 1px
        background-color: #e60012
        margin-top: 20px

    /* 省份 / 城市 下拉查询区（左右排列、整体居中） */
    .panel_search
        display: flex
        justify-content: center
        padding-top: 40px

    .search_form
        .el-form-item
            margin-right: 30px
            margin-bottom: 0

            &:last-child
                margin-right: 0

    /* 授权实体店列表 */
    .dealer_list
        padding-top: 10px

    /* 官方授权网店 */
    .online_list
        display: flex
        justify-content: center
        padding-top: 35px

    .online_item
        cursor: pointer
        text-align: center
        margin: 0 32px

    .online_icon
        display: block
        width: 80px
        height: 80px
        border-radius: 16px
        margin: 0 auto

    .online_name
        margin-top: 12px
        font-size: 14px
        color: #333

    /* 官方查询小程序图片（原图 1280x1280，等比放大显示） */
    .online_qrcode
        display: block
        width: 170px
        height: 170px
        border-radius: 8px
        margin: 0 auto

</style>
